import React, { useRef } from "react";
import { InputAdornment, makeStyles, withStyles } from "@material-ui/core";
import {
  Grid,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Link,
} from "@material-ui/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { store } from "../../../../helpers";
import { useEffect } from "react";
import { black, red500 } from "material-ui/styles/colors";
import { config } from "../../../../enviroment";
import { useHistory } from "react-router-dom";
import { routePaths } from "../../../config/route-paths";
import { AlertTitle, Alert, Skeleton } from "@material-ui/lab";
import { adminService } from "../../../../services/admin.service";
import { useTranslation } from "react-i18next";
import HelpRoundedIcon from '@material-ui/icons/HelpRounded';
import { Tooltip } from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";

export const CssTextField = withStyles((theme) => ({
  root: {
    "& .MuiInputBase-input": {
      padding: "2px !important",
      fontSize: "0.8em",
    },
    "& .MuiInputBase-input:focus": {
      fontSize: "1rem",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      ["@media (min-width:768px)"]: {
        width: "32vw",
      },
      ["@media (min-width:900px)"]: {
        width: "30vw",
      },
      ["@media (min-width:1025px)"]: {
        width: "16vw",
      },
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark,
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.eDanger?.dark,
    },
  },
}))(TextField);

export const customGrid = withStyles((theme) => ({
  root: {
    "& .MuiGrid-item": {
      margin: 0,
      boxSizing: "border-box",
      width: "99%",
    },
  },
}))(Grid);
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor:theme.palette.ePrimary?.base,
    boxShadow: theme.shadows[1],
    color: theme.palette.eWhite?.base,
    fontSize : '0.7rem',
    marginBottom:'0.4rem'
  },
}))(Tooltip);
export default function ERegister(props) {
  const { handlecancel, handleFail, handleRegister } = props;
  let FLNameRequired = "false";
  let isVerification = "false";
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [accountNo, setAccountNo] = useState("");
  const [emailId, setEmailId] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstNameRequire, setFirstNameRequire] = useState(false);
  const [firstNameRegexError, setfirstNameRegexError] = useState(false);
  const [lastNameRequire, setlastNameRequire] = useState(false);
  const [LastNameRegexError, setlastNameRegexError] = useState(false);
  const [accountNoRequire, setAccountNoRequire] = useState(false);
  const [accountNoError, setAccountNoError] = useState(false);
  const [mobileNoRequire, setMobileNoRequire] = useState(false);
  const [emailRequire, setEmailRequire] = useState(false);
  const [passwordRequire, setPasswordRequire] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordRequire, setConfirmPasswordRequire] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [isOTPOn, setisOTPOn] = useState(false);
  const [errorFinal, seterrorFinal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  let [accountIdNotFound, setAccountIdError] = useState(false);
  let [errorMessage, setErrorMessage] = useState("");
  const [content, setContent] = useState("");
  const history = useHistory();
  const captchaRef = useRef();
  const [captcha, setCaptcha] = useState("");
  const [disabled, setDisabled] = useState(true)

  const useStyles = makeStyles((theme) => ({
    alertStyles: {
      color: theme.palette.eDanger.dark,
      backgroundColor: theme.palette.eDanger.light,
    },
    scrollBar: {
      display: "block",
      flexDirection: "column",
      padding: "1%",
      overflow: "scroll",
      overflowX: "hidden",
      width: "inherit !important",
      margin: "1% 4%",
      padding: "0% 5%",
      "&::-webkit-scrollbar": {
        width: "0.4em",
      },
      "&::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.eLight.base,
        borderRadius: 4,
      },
      [theme.breakpoints.up("xs")]: {
        height: "initial",
      },
      [theme.breakpoints.up("lg")]: {
        height: "400px",
      },
    },
    cancelButton: {
      textTransform: "none",
      color: theme.palette.ePrimary.base,
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      textDecoration: "underline",
      display: "inline",
      margin: 0,
      padding: 0,
    },
    loginSubmitBtn: {
      "&:hover": {
        backgroundColor: theme.palette.ePrimary.hover,
      },
      backgroundColor: theme.palette.ePrimary.base,
      width: "75%",
      height: "35px",
      borderRadius: 28,
      color: theme.palette.eWhite.base,
    },
    mobileNumberError: {
      fontSize: "0.75em",
      color: theme.palette.eDanger?.dark + "!important",
      textAlign: "left",
    },
    registerTitle: {
      color: theme.palette.ePrimary.base,
      // paddingBottom: "3%",
    },
    blackColor: {
      color: theme.palette.eRich.base + "!important",
    },circularProgressColor:{
      color: theme.palette.eWhite.base + "!important",
    },
    asterisk: {
      color: theme.palette.eDanger?.dark
    },
    alertStyle: {
      color: theme.palette.eDanger.dark,
      backgroundColor: theme.palette.eDanger.light,
    },
    tooltip:{
      color: theme.palette.eMedium?.base,
      fontSize : '1.3rem',
      marginBottom:'0.4rem'
    },
    captchaAlignment: {
     position:'relative'
    },
    centerCaptcha:{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      alignSelf:'center',
      position:'relative',
      zIndex:'2',
      [theme.breakpoints.up('xs')]: {
        scale:'0.85',
        left:'-27px',
      },
      [theme.breakpoints.down('md')]: {
        scale:'0.87',
        left:'-20px',
      },
      [theme.breakpoints.up('md')]: {
        scale:'0.85',
        left:'-23px',
        
      },
      [theme.breakpoints.up('lg')]: {
        scale:'0.85',
        left:'-23px',
      },
    }
  }));
  const { t: labels, ready: labelReady } = useTranslation("label-E_REGISTER");
  const { t: labelsLog, ready: labelReadyLog } = useTranslation("label-E_AUTH_LOGIN");
  const { t: Errorlabels, ready: errLabelReady } = useTranslation("label-E_SIGNUP_FAILURE_SCENARIOS");
  const { t: errorContent, ready: errorContentReady } = useTranslation("content-E_SIGNUP_FAILURE_SCENARIOS");

  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const classes = useStyles();
  let tenantIdNo = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_TENANT_IDENTIFICATION_NUMBER
  );
  FLNameRequired = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_FIRST_LAST_NAME_FIELD
  );
  const nameMinLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.NAME_MIN_LENGTH);
  let accountLength =
    store.getState()?.parametersWidgets?.ParameterLookup
      ?.E_PRIMARY_IDENTIFIER_LENGTH;
  let minAccountLength =useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_MIN_CN_LENGTH);
  accountLength = Number(accountLength);

  let country_Calling_Code =
    store.getState()?.parametersWidgets?.ParameterLookup
      ?.E_PHONE_NUMBER_EXTENSION;

      let country_Calling_Code_backend =
      store.getState()?.parametersWidgets?.ParameterLookup
        ?.E_MOBILE_NUMBER_EXTENSION_BACKEND;
     
      
  isVerification =
    store.getState()?.parametersWidgets?.ParameterLookup
      ?.E_IS_VERIFICATION_FAILURE;
  const emailRegex =
    store.getState()?.parametersWidgets?.ParameterLookup?.E_EMAIL_REGEX;
  let MOBILE_LENGTH =
    store.getState()?.parametersWidgets?.ParameterLookup?.E_MOBILE_LENGTH;
  MOBILE_LENGTH = Number(MOBILE_LENGTH);
  const passwordRegex =
    store.getState()?.parametersWidgets?.ParameterLookup?.E_PASSWORD_REGEX;
  const nameRegex =
    store.getState()?.parametersWidgets?.ParameterLookup?.E_NAME_REGEX;
  const digitsRegex =
    store.getState()?.parametersWidgets?.ParameterLookup?.E_DIGITS_REGEX;
    const englishRegex =
    store.getState()?.parametersWidgets?.ParameterLookup?.E_ENGLISH_REGEX;
  const accountNumberRegex =
    store.getState()?.parametersWidgets?.ParameterLookup?.E_DIGITS_REGEX;

  let E_SIGNUP_OTP_VALIDATION = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_SIGNUP_OTP_VALIDATION
  );

  let enableCaptcha = useSelector((store) => store?.parametersWidgets.ParameterLookup?.ENABLE_CAPTCHA)

  let [E_ACCOUNT_ID_NOT_FOUND, setAccountIDNotFoundContent] = useState("");
  let [E_ACCOUNT_ALREADY_EXISTS, setAccountExitsContent] = useState("");
  let [E_VERFICATION_FAILURE_SERVER_ERROR, setServerError] = useState("");

  useEffect(() => {
    if(errorContentReady) {
      setAccountIDNotFoundContent(
        errorContent("E_ACCOUNT_ID_NOT_FOUND")?.answer
      );
      setAccountExitsContent(
        errorContent("E_ACCOUNT_ALREADY_EXISTS")?.answer?.replace(
          "*class*",
          classes.LoginURL
        )
      );
      setServerError(
        errorContent("E_VERFICATION_FAILURE_SERVER_ERROR")?.answer
      );
    }
  }, [errorContentReady]);
  
  let handleChange = (event) => {
    let englishRegexText =new RegExp(englishRegex);
    const { name, value } = event.target;
    if (englishRegexText.test(value)) {
      if (name === "firstName") {
        setFirstName(value);
      }
      if (name === "lastName") {
        setLastName(value);
      }
      if (name === "password") {
        setPassword(value);
      }
      if (name === "confirmPassword") {
        setConfirmPassword(value);
      }
    }else if (value==""){
      if (name === "firstName") {
        setFirstName(value);
      }
      if (name === "lastName") {
        setLastName(value);
      }
      if (name === "password") {
        setPassword(value);
      }
      if (name === "confirmPassword") {
        setConfirmPassword(value);
      }
    }
    if (name === "accountNo") {
      setAccountNo(value);
    }
    if (name === "mobileNo") {
      setMobileNo(value);
    }
    if (name === "emailId") {
      setEmailId(value);
    }
  };

  let handleChangeEvent = (event) => {
    const { name, value } = event.target;
    if (name === "mobileNo" || name === "accountNo") {
      var digitsRegexS = new RegExp(digitsRegex);
      if (event.target.value === "" || digitsRegexS.test(event.target.value)) {
        if (name === "accountNo") {
          setAccountNo(value);
        }
        if (name === "mobileNo") {
          setMobileNo(value);
        }
      }
    }
  };

  let onKeyDown = (event) => {
    if (event.which === 38 || event.which === 40) {
      event.preventDefault();
    }
  };
  let firstNameBlur = () => {
    if (firstName) {
      setFirstNameRequire(false);
      seterrorFinal(false);
    } else {
      setFirstNameRequire(true);
    }
    if (store.getState().parametersWidgets.ParameterLookup) {
      if (firstName.length >= Number(nameMinLength)) {
        setfirstNameRegexError(false);
        seterrorFinal(false);
      } else {
        setfirstNameRegexError(true);
        seterrorFinal(false);
      }
    }
  };
  let lastNameBlur = () => {
    if (lastName) {
      setlastNameRequire(false);
      seterrorFinal(false);
      if (store.getState().parametersWidgets.ParameterLookup) {
        if (lastName.length >= Number(nameMinLength)) {
          setlastNameRegexError(false);
          seterrorFinal(false);
        } else {
          setlastNameRegexError(true);
          seterrorFinal(false);
        }
      }
    } else {
      setlastNameRequire(true);
      seterrorFinal(false);
      setlastNameRegexError(false);
    }
  };

  let accountNumberBlur = () => {
    if (accountNo) {
      setAccountNoRequire(false);
      seterrorFinal(false);
      if (store.getState().parametersWidgets.ParameterLookup) {
        var accountRegex = new RegExp(accountNumberRegex);
        if ((accountNo.length <= accountLength && accountNo.length>=parseInt(minAccountLength)) && accountRegex.test(accountNo)) {
          setAccountNoError(false);
        } else {
          setAccountNoError(true);
        }
      }
    } else {
      setAccountNoRequire(true);
      seterrorFinal(false);
      setAccountNoError(false);
    }
  };

  let mobileBlur = () => {
    if (mobileNo) {
      setMobileNoRequire(false);
      if (store.getState().parametersWidgets.ParameterLookup) {
        if (mobileNo.length === Number(MOBILE_LENGTH)) {
          setMobileError(false);
        } else {
          setMobileError(true);
        }
      }
    } else {
      setMobileNoRequire(true);
      setMobileError(false);
    }
  };

  let emailBlur = () => {
    if (emailId) {
      setEmailRequire(false);
      seterrorFinal(false);
      let emailRegExp = new RegExp(emailRegex);
      if (emailRegExp.test(emailId)) {
        setEmailError(false);
      } else {
        setEmailError(true);
      }
    } else {
      setEmailError(false);
      seterrorFinal(false);
    }
  };

  let passwordBlur = () => {
    if (password.trim()) {
      setPasswordRequire(false);
      seterrorFinal(false);
      let passwordRegExp = new RegExp(passwordRegex);
      if (passwordRegExp.test(password)) {
        setPasswordError(false);
      } else {
        setPasswordError(true);
        setConfirmPasswordError(false);
      }
    } else {
      setPasswordRequire(true);
      setPasswordError(false);
      seterrorFinal(false);
    }
  };

  let confirmPasswordBlur = () => {
    if (confirmPassword) {
      setConfirmPasswordRequire(false);
      seterrorFinal(false);
      if (confirmPassword && password) {
        if (confirmPassword === password) {
          setConfirmPasswordError(false);
        } else {
          setConfirmPasswordError(true);
          setPasswordRequire(false);
          setPasswordError(false);
        }
      } else {
        setConfirmPasswordError(false);
        setPasswordRequire(false);
        setPasswordError(false);
      }
    } else {
      setConfirmPasswordRequire(true);
      setConfirmPasswordError(false);
      seterrorFinal(false);
    }
  };

  let keypress = (event) => {
    if (event.key === "Enter") {
      passwordBlur();
      confirmPasswordBlur();
      if (!isLoading) {
        registerSubmit(event);
      }
    }
  };
  useEffect(() => {
    if (isOTPOn) {
      history.push(routePaths.SIGN_UP_VERIFY_OTP);
    }
  }, [isOTPOn]);
  let registerSubmit = (e) => {
    if (FLNameRequired !== "false") {
      firstNameBlur();
      lastNameBlur();
    }
    accountNumberBlur();
    emailBlur();
    mobileBlur();
    passwordBlur();
    confirmPasswordBlur();
    if (accountNo && mobileNo && password && confirmPassword) {
      if (
        !accountNoRequire &&
        !accountNoError &&
        !emailRequire &&
        !emailError &&
        !mobileNoRequire &&
        !mobileError &&
        !passwordRequire &&
        !passwordError &&
        !confirmPasswordRequire &&
        !confirmPasswordError &&
        !disabled
      ) {
        setLoading(true);
        let data = {
          firstName,
          lastName,
          accountNo,
          emailId,
          country_Calling_Code_backend,
          mobileNo,
          password,
          confirmPassword,
          tenantIdNo,
          FLNameRequired,
        };
        props
          .verifySignUp(data)
          .then((response) => {
            if (response.data.isVerified === "false") {
              localStorage.setItem(
                "verification",
                JSON.stringify(response.data)
              );
              handleFail();
            } else {
              localStorage.setItem("flowType", "SIGNUP");
              let mobile = mobileNo.slice(mobileNo.length - 4, mobileNo.length);
              history.push({
                pathname: routePaths.SIGN_UP_VERIFY_OTP,
                state: {
                  path: routePaths.REGISTER,
                  userName: response?.data?.userName,
                  mobile: mobile,
                },
              });
              if (E_SIGNUP_OTP_VALIDATION) {
                setisOTPOn(true);
              }
              isLoading(false);
            }
          })
          .catch((error) => {
            if (error?.response?.status === 400) {
              if (
                error?.response?.data?.message === "ACCOUNT_NUMBER_NOT_FOUND"
              ) {
                setErrorMessage(E_ACCOUNT_ID_NOT_FOUND);
                setAccountIdError(true);
              } else if (
                error?.response?.data?.message === "EMAIL_ALREADY_EXISTS"
              ) {
                setErrorMessage(E_ACCOUNT_ALREADY_EXISTS);
                setAccountIdError(false);
              }else if (error?.response?.data?.message?.includes("is not the primary Contact")){
                const contactMatch = error?.response?.data?.message?.match(/\/(.*?)\//);
                if (contactMatch) {
                  const extractedText = contactMatch[1];
                  let updatedError = labelReadyLog ? labelsLog("SECONDARY_ERROR"): "";
                  updatedError=updatedError?.replace("****", extractedText) 
                  setErrorMessage(updatedError)
                }
              }
              setLoading(false);
            } else if (error?.response?.status === 404) {
              history.push({
                pathname: routePaths.SIGN_UP_VERIFICATION_FAIL,
                state: { data: error?.response?.data },
              });
              setLoading(false);
            } else if (error?.response?.status === 403) {
              setErrorMessage(error?.response?.data?.message);
              setAccountIdError(false);
              setLoading(false);
            } else {
              setErrorMessage(E_VERFICATION_FAILURE_SERVER_ERROR);
              setAccountIdError(false);
              seterrorFinal(true);
              setLoading(false);
            }
          });
      }
    } else {
      setConfirmPasswordRequire(true);
      setConfirmPasswordError(false);
    }
  };
  let loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };
  // useEffect(() => {
  //   loadScript(config.recaptcha.SITE_URL);
  // }, []);

  useEffect(() => {
    if (disabled === false) {
      setDisabled(true);
    }
    setTimeout(() => {
      setCaptcha({ ...captcha, load: true });
    }, 500);
  }, []);

  useEffect(() => {
    if (firstName.trim().length > 0 && lastName.trim().length > 0 && accountNo.length > 0 && mobileNo.length === MOBILE_LENGTH && password.trim().length > 0 && confirmPassword.trim().length === password.trim().length && captcha?.value) {
      setDisabled(false)
    }
    else {
      setDisabled(true)
    }
  }, [firstName, lastName, accountNo, mobileNo, password, confirmPassword, captcha])

  const captchaHandleExpired = (value) => {
    captchaRef.reset();
  }

  const captchaAsyncScriptOnLoad = () => {
    setCaptcha({
      ...captcha,
      callback: "called!",
    });
  };

  const captchaHandleChange = (value) => {
    setCaptcha({
      ...captcha,
      value: value,
    });
    if (value !== null && firstName.trim().length > 0 && lastName.trim().length > 0 && accountNo.length && mobileNo.length > 0 && password.trim().length > 0 && confirmPassword.trim().length > 0)
      setDisabled(false);
    if (value === null)
      setCaptcha({
        ...captcha,
        expired: true,
      });
  };


  return (
    <>
      <form noValidate>
        <Grid container direction="row">
          <Grid item xs={12}>
          {
            labelReady?
            <Typography
              align="center"
              variant="h5"
              className={classes.registerTitle}
            >
              {labels("E_REGISTER_TITLE")}
            </Typography>
            :<Skeleton />
          }
          </Grid>
          <Grid item xs={12}>
            <Grid container className={classes.scrollBar} spacing={1}>
              {FLNameRequired !== "false" && (
                <>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}>
                      {
                        labelReady ?
                        <Typography
                          variant="subtitle2"
                          align="left"
                          className={classes.blackColor}
                        >
                          {labels("E_FIRST_NAME")}<span className={classes.asterisk}>*</span>
                        </Typography>
                        : <Skeleton />
                      }
                      </Grid>
                      <Grid item xs={12}>
                        <CssTextField
                          align="center"
                          inputProps={{
                            pattern: '[a-zA-Z\s]*', 
                          }}
                          placeholder={labelReady ? labels("E_FIRST_NAME_PLACEHOLDER") : ''}
                          value={firstName}
                          autoComplete="off"
                          name="firstName"
                          fullWidth
                          onChange={handleChange}
                          onBlur={firstNameBlur}
                          error={firstNameRequire || firstNameRegexError}
                        />
                      </Grid>
                      {
                        labelReady ?
                      <Typography className={classes.mobileNumberError}>
                        {firstNameRequire
                          ? labels("E_FIRST_NAME_ERROR")
                          : firstNameRegexError
                          ? labels("E_FIRST_NAME_NOT_VALID")
                          : null}
                      </Typography>
                      : <Skeleton />
                      }
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}>
                      {
                        labelReady ?
                        <Typography
                          variant="subtitle2"
                          align="left"
                          className={classes.blackColor}
                        >
                          {labels("E_LAST_NAME")}<span className={classes.asterisk}>*</span>
                        </Typography>
                        : <Skeleton />
                      }
                      </Grid>
                      <Grid item xs={12}>
                        <CssTextField
                          align="center"
                          placeholder={labelReady ? labels("E_LAST_NAME_PLACEHOLDER") : ''}
                          variant="standard"
                          fullWidth
                          value={lastName}
                          autoComplete="off"
                          name="lastName"
                          onChange={handleChange}
                          onBlur={lastNameBlur}
                          error={lastNameRequire || LastNameRegexError}
                        />
                      </Grid>
                      {
                        labelReady ?
                      <Typography className={classes.mobileNumberError}>
                        {lastNameRequire
                          ? labels("E_LAST_NAME_ERROR")
                          : LastNameRegexError
                          ? labels("E_LAST_NAME_NOT_VALID")
                          : null}
                      </Typography>
                      : <Skeleton />
                      }
                    </Grid>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                  {
                    labelReady ?
                    <Typography
                      variant="subtitle2"
                      align="left"
                      className={classes.blackColor}
                    >
                      {labels("E_ACCOUNT_NUMBER")}<span className={classes.asterisk}>*</span>
                    </Typography>
                    : <Skeleton />
                  }
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      align="center"
                      fullWidth
                      placeholder={labelReady ? labels("E_ACCOUNT_NUMBER_PLACEHOLDER") : ''}
                      // variant="standard"
                      autoComplete="off"
                      name="accountNo"
                      onChange={handleChangeEvent}
                      onBlur={accountNumberBlur}
                      value={accountNo}
                      inputProps={{
                        maxLength: accountLength,
                      }}
                      onKeyDown={onKeyDown}
                      error={accountNoRequire || accountNoError}
                    />
                  </Grid>
                  {
                    labelReady ?
                  <Typography className={classes.mobileNumberError}>
                    {accountNoRequire
                      ? labels("E_ACCOUNT_NUMBER_REQUIRED_ERROR")
                      : accountNoError
                      ? labels("E_ACCOUNT_NUMBER_VALIDATION_ERROR")
                      : null}
                  </Typography>
                  : <Skeleton />
                  }
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                  {
                    labelReady ?
                    <Typography
                      align="left"
                      variant="subtitle2"
                      className={classes.blackColor}
                    >
                      {labels("E_MOBILE_NUMBER")}<span className={classes.asterisk}>*</span>
                    </Typography>
                    : <Skeleton />
                  }
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container direction="row" spacing={1}>
                      {/* <Grid item xs={2}>
                        <CssTextField
                          value={country_Calling_Code}
                          variant="standard"
                          autoComplete="off"
                          error={mobileNoRequire || mobileError}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid> */}
                      <Grid item xs={12}>
                        <CssTextField
                          align="center"
                          placeholder={labelReady ? labels("E_MOBILE_NUMBER_PLACEHOLDER") : ''}
                          variant="standard"
                          fullWidth
                          autoComplete="off"
                          name="mobileNo"
                          onChange={handleChangeEvent}
                          onBlur={mobileBlur}
                          value={mobileNo}
                          inputProps={{
                            maxLength: MOBILE_LENGTH,
                          }}
                          onKeyDown={onKeyDown}
                          error={mobileNoRequire || mobileError}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">{country_Calling_Code_backend}</InputAdornment>,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {
                    labelReady ?
                  <Typography className={classes.mobileNumberError}>
                    {mobileNoRequire
                      ? labels("E_MOBILE_NUMBER_ERROR")
                      : mobileError
                      ? labels("E_MOBILE_NUMBER_VALIDATION_ERROR")
                      : null}
                  </Typography>
                  : <Skeleton />
                  }
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                  {
                    labelReady ?
                    <Typography
                      variant="subtitle2"
                      align="left"
                      className={classes.blackColor}
                    >
                      {labels("E_EMAIL_ID")}
                    </Typography>
                    : <Skeleton />
                  }
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      fullWidth
                      align="center"
                      placeholder={labelReady ? labels("E_EMAIL_ID_PLACEHOLDER") : ""}
                      variant="standard"
                      autoComplete="off"
                      name="emailId"
                      onChange={handleChange}
                      onBlur={emailBlur}
                      value={emailId}
                      error={emailRequire || emailError}
                    />
                  </Grid>
                  {
                    labelReady ?
                  <Typography className={classes.mobileNumberError}>
                    {emailRequire
                      ? labels("E_EMAIL_REQUIRED_ERROR")
                      : emailError
                      ? labels("E_EMAIL_NOT_VALID_ERROR")
                      : null}
                  </Typography>
                  : <Skeleton />
                  }
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                  {
                    labelReady ?
                    <Typography
                      variant="subtitle2"
                      align="left"
                      className={classes.blackColor}
                    >
                      {labels("E_PASSWORD")}<span className={classes.asterisk}>*</span>&nbsp;<LightTooltip placement="right-start" enterTouchDelay={0} title={labelReady ? labels("E_PASSWORD_VALIDATION_ERROR") : ''}><HelpRoundedIcon className={classes.tooltip} ></HelpRoundedIcon></LightTooltip>
                    </Typography>
                    : <Skeleton />
                  }
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      fullWidth
                      align="center"
                      placeholder={labelReady ? labels("E_PASSWORD_PLACEHOLDER") : ""}
                      variant="standard"
                      className={classes.inpField}
                      name="password"
                      value={password}
                      type="password"
                      onChange={handleChange}
                      onBlur={passwordBlur}
                      autoComplete="off"
                      error={
                        passwordRequire || passwordError || confirmPasswordError
                      }
                    />
                  </Grid>
                  {
                    labelReady ?
                  <Typography className={classes.mobileNumberError}>
                    {passwordRequire
                      ? labels("E_PASSWORD_ERROR")
                      : passwordError
                      ? labels("E_PASSWORD_VALIDATION_ERROR")
                      : null}
                  </Typography>
                  : <Skeleton />
                  }
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                  {
                    labelReady ?
                    <Typography
                      variant="subtitle2"
                      align="left"
                      className={classes.blackColor}
                    >
                      {labels("E_CONFIRM_PASSWORD")}<span className={classes.asterisk}>*</span>
                    </Typography>
                    : <Skeleton />
                  }
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      align="center"
                      placeholder={labelReady ? labels("E_CONFIRM_PASSWORD_PLACEHOLDER") : ''}
                      variant="standard"
                      type="password"
                      fullWidth
                      autoComplete="off"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleChange}
                      onKeyPress={keypress}
                      onBlur={confirmPasswordBlur}
                      error={confirmPasswordRequire || confirmPasswordError}
                    />
                  </Grid>
                  {
                    labelReady ?
                  <Typography className={classes.mobileNumberError}>
                    {confirmPasswordRequire
                      ? labels("E_CONFIRM_PASSWORD_ERROR")
                      : confirmPasswordError
                      ? labels("E_PASSWORD_CONFIRM_PASSWORD_MATCH_ERROR")
                      : null}
                  </Typography>
                  : <Skeleton />
                  }
                </Grid>
              </Grid>
              {errorMessage ? (
                <Grid item xs={12} className={classes.mt4}>
                  <Alert severity="error" className={classes.alertStyles}>
                    <AlertTitle>
                      {accountIdNotFound && (
                        <>
                          <Typography variant="body2" align="left">
                            <strong>
                              {errLabelReady ? Errorlabels("E_ACCOUNT_NUMBER_NOT_FOUND") : <Skeleton />}
                            </strong>
                          </Typography>
                        </>
                      )}
                    </AlertTitle>
                    <Typography
                      variant="body2"
                      align="left"
                      dangerouslySetInnerHTML={{
                        __html: errorMessage,
                      }}
                    />
                  </Alert>
                </Grid>
              ) : null}
              <Grid item xs={12}>
                <Grid container style={{position:'relative'}}>
                  {captcha.load && enableCaptcha && (
                  <ReCAPTCHA 
                    style={{ display: "inline-block"}}
                    theme="light"
                    ref={captchaRef}
                    sitekey={config.recaptcha.SITE_KEY}
                    onChange={captchaHandleChange}
                    asyncScriptOnLoad={captchaAsyncScriptOnLoad}
                    size="normal"
                    onExpired={captchaHandleExpired}
                    className={classes.centerCaptcha}
                  />)
                  }
                </Grid>
              </Grid>
              <Grid item xs={12} >
                <Button
                  variant="contained"
                  disabled={disabled}
                  fullWidth
                  onClick={registerSubmit}
                  data-sitekey={config.recaptcha.SITE_KEY}
                  data-action="register"
                  className={[classes.loginSubmitBtn, classes.cursor]}
                >
                  {labelReady ? labels("E_REGISTER_BUTTON") : <Skeleton />} &nbsp;
                  {isLoading ? (
                    <CircularProgress
                      size={18}
                      className={classes.circularProgressColor}
                    />
                  ) : (
                    " "
                  )}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  onClick={() => {
                    history.push(routePaths?.LOGIN);
                  }}
                  className={classes.cancelButton}
                >
                  {labelReady ? labels("E_CANCEL_BUTTON") : <Skeleton />}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
